module.exports = __webpack_public_path__ + "static/media/seta_down.b351e8d2.svg";